import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext } from 'react';
import { useModal } from 'store/modals';
import { useDeleteUser } from 'services/admin/delete-user';
import { Icon } from 'semantic-ui-react';
import { Button } from 'components/form-elements/buttons/Button';
import { Text } from 'components/typography';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export const DeleteUser = () => {
  const intl = useIntl();
  const { openModal } = useModal();
  const { selectedUser, setSelectedUser } = useContext(UserAdministrationModalContext);

  const { deleteUserAsync } = useDeleteUser({
    onSuccess: () => {
      setSelectedUser(null);
    },
  });

  function onDeleteUser() {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        type: 'warning',
        title: intl.formatMessage({
          id: 'removeUser',
        }),
        content: intl.formatMessage({
          id: 'deleteUserWarning',
        }),
        onConfirm: () => deleteUserAsync(selectedUser.id),
      },
    });
  }

  return (
    <Button
      type="button"
      className={styles.deleteBtn}
      onClick={() => onDeleteUser()}
    >
      <div className={styles.deleteBtnContent}>
        <Icon
          name="remove circle"
          size="large"
        />
        <Text
          underline
          red
          medium
        >
          <FormattedMessage id="deleteUserPermanently" />
        </Text>
      </div>
    </Button>
  );
};
